import { get } from 'lodash';
import * as React from 'react';
import { connect } from 'react-redux';
import { GenericProductsContribution } from '../../../../../components/widgets/airport/providers/provider-products/generic-product/generic-product-contribution/generic-products-contribution';
import { connectNLP } from '../../../../../utilities/connect-navigate';
import { Contributions } from '../contributions';

const mapStateProps = (store: any) => ({
	user: store.user.user,
});

const mapDispatchProps = (dispatch: any) => ({});

class GenericProductContributionsComponent extends Contributions<any, any> {
	public endpoint(): any {
		const user = get(this.props, 'user');
		const userRoles = get(user, 'roles');
		const isAdmin = userRoles.includes('ADMIN');
		const system = get(this.props, 'system');
		const systemInfo = system === true ? '/system' : `/users/${system}`;
		const otherInfo = isAdmin ? '' : `/users/${get(user, 'aid')}`;

		const systemAdminOrGeneral = isAdmin && system ? systemInfo : otherInfo;

		return `/providerproducts/contributions${systemAdminOrGeneral}`;
	}

	public getType(): string {
		return 'genericproducts';
	}

	public getModalEndpoint() {
		return `/providerproducts/${get(this.state.item, 'entityAid')}`;
	}

	public renderModalContent(ctx): React.ReactElement {
		return (
			<GenericProductsContribution
				item={this.state.item}
				onSuccess={() => this.handleModalSuccess()}
				close={() => this.onModalClose()}
				original={get(ctx.state, 'response')}
			/>
		);
	}
}

export const GenericProductContributions: any = connect(
	mapStateProps,
	mapDispatchProps,
	null,
	{ forwardRef: true }
)(connectNLP(GenericProductContributionsComponent));
